module.exports = __webpack_public_path__ + "static/img/7.045917e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/7.png
// module id = E8bI
// module chunks = 0